/* tslint:disable */
/* eslint-disable */
/**
 * Aggregator
 * Main api for wealth management application
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@illio.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../base';
// @ts-ignore
import { BarData } from '../../aggregator';
// @ts-ignore
import { PortfolioGetHistoryReportRequest } from '../../aggregator';
// @ts-ignore
import { ReportIncome } from '../../aggregator';
// @ts-ignore
import { ReportIncomeRequest } from '../../aggregator';
/**
 * PortfolioReportsControllerApi - axios parameter creator
 * @export
 */
export const PortfolioReportsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary getPortfolioHistoryBreakdown
         * @param {PortfolioGetHistoryReportRequest} request request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioHistoryBreakdownUsingPOST: async (request: PortfolioGetHistoryReportRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('getPortfolioHistoryBreakdownUsingPOST', 'request', request)
            const localVarPath = `/api/v1/report.history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getPortfolioIncome
         * @param {ReportIncomeRequest} request request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioIncomeUsingPOST: async (request: ReportIncomeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('getPortfolioIncomeUsingPOST', 'request', request)
            const localVarPath = `/api/v1/report.income`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioReportsControllerApi - functional programming interface
 * @export
 */
export const PortfolioReportsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioReportsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary getPortfolioHistoryBreakdown
         * @param {PortfolioGetHistoryReportRequest} request request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioHistoryBreakdownUsingPOST(request: PortfolioGetHistoryReportRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BarData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioHistoryBreakdownUsingPOST(request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary getPortfolioIncome
         * @param {ReportIncomeRequest} request request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioIncomeUsingPOST(request: ReportIncomeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportIncome>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioIncomeUsingPOST(request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PortfolioReportsControllerApi - factory interface
 * @export
 */
export const PortfolioReportsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioReportsControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary getPortfolioHistoryBreakdown
         * @param {PortfolioGetHistoryReportRequest} request request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioHistoryBreakdownUsingPOST(request: PortfolioGetHistoryReportRequest, options?: any): AxiosPromise<Array<BarData>> {
            return localVarFp.getPortfolioHistoryBreakdownUsingPOST(request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getPortfolioIncome
         * @param {ReportIncomeRequest} request request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioIncomeUsingPOST(request: ReportIncomeRequest, options?: any): AxiosPromise<ReportIncome> {
            return localVarFp.getPortfolioIncomeUsingPOST(request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortfolioReportsControllerApi - object-oriented interface
 * @export
 * @class PortfolioReportsControllerApi
 * @extends {BaseAPI}
 */
export class PortfolioReportsControllerApi extends BaseAPI {
    /**
     * 
     * @summary getPortfolioHistoryBreakdown
     * @param {PortfolioGetHistoryReportRequest} request request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioReportsControllerApi
     */
    public getPortfolioHistoryBreakdownUsingPOST(request: PortfolioGetHistoryReportRequest, options?: AxiosRequestConfig) {
        return PortfolioReportsControllerApiFp(this.configuration).getPortfolioHistoryBreakdownUsingPOST(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getPortfolioIncome
     * @param {ReportIncomeRequest} request request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioReportsControllerApi
     */
    public getPortfolioIncomeUsingPOST(request: ReportIncomeRequest, options?: AxiosRequestConfig) {
        return PortfolioReportsControllerApiFp(this.configuration).getPortfolioIncomeUsingPOST(request, options).then((request) => request(this.axios, this.basePath));
    }
}
